import React, { Fragment, useState } from 'react'
// import { useHistory } from "react-router-dom";
import { closeModal } from "../../app/common/modals/modalReducer";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheckCircle, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { Dialog, Transition } from '@headlessui/react';
import { faExclamation, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import CustomButton from '../../app/common/form/CustomButton';

export default function OrderBackorder(props) {
    // let history = useHistory();
    const dispatch = useDispatch();
    const [open] = useState(true);

    // console.log(props.errors)

    let backorders = props.backorders;

    console.log(backorders)

    // let modalIcon = faCheckCircle;
    // let modalIconClass = "my-4 text-2xl ";

    return (
        <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 transition ease-in duration-300"
                    aria-hidden="true"
                >
                    <div className="absolute inset-0 bg-black opacity-50"></div>
                </div>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                    &#8203;
                </span>

                <div
                    className="
                        inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 
                        overflow-hidden shadow-xl transform transition-all 
                        sm:align-middle
                        sm:max-w-4xl sm:w-full sm:p-6
                    "
                >
                    <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                        <button
                            type="button"
                            className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0"
                            onClick={() => dispatch(closeModal())}
                        >
                            <span className="sr-only">Close</span>
                            <FontAwesomeIcon className="text-lk_red text-2xl hover:text-lk_red_hover" aria-hidden="true" icon={faTimesCircle} />
                        </button>
                    </div>
                    <div>
                        <div className="mt-3 text-center sm:mt-16">
                            <h1 className="text-2xl sm:text-3xl lg:text-5xl" style={{ "textWrap": "balance" }}>
                                Some of the Items you ordered are out of stock
                            </h1>
                            <div className="mt-12 mb-5">
                                <p className="text-xl">Items:</p>
                                <br />
                                <div style={{ maxHeight: '30vh', 'overflow': 'auto' }}>
                                    <ul className="text-left">
                                        {backorders.map((backorder, index) => (
                                            <li className='text-center'>
                                                <FontAwesomeIcon icon={faExclamation} style={{ color: "red" }} /> {backorder.StockCode} You ordered {backorder.ordered} unit/s and have {backorder.customer_backorder} unit/s on backorder.
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <br /><br />
                                <div className="flex justify-center">

                                    <CustomButton
                                        type="button"
                                        text="place order"
                                        className="lkbutton bg-red-600 hover:bg-red-700 w-32 sm:w-96 border_radius_10 mr-5"
                                        onClick={() => { props.setBackorderAsk(true); props.setReRunOrder(true); dispatch(closeModal()) }}
                                    />
                                    <CustomButton
                                        type="button"
                                        text="Update Cart"
                                        className="lkbutton bg-gray-500 hover:bg-gray-600 w-32 sm:w-96 border_radius_10"
                                        onClick={() => { props.setBackorderAsk(true); dispatch(closeModal()) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}